// INTERFACE
import { FooterProps } from 'layout/Footer/Footer.interface';

export const footerDefaultData: FooterProps = {
  brand: '© 2021 NTUC Health Co-operative Ltd. All Rights Reserved'
};
